import { useTheme } from "../context/ThemeContext";
import { Moon, Sun } from "lucide-react";

export function DarkModeToggle({ className = "" }) {
  const { dark, toggle } = useTheme();
  return (
    <button
      data-testid="dark-mode-toggle"
      onClick={toggle}
      className={`p-2 rounded-lg transition-colors ${dark ? "text-yellow-400 hover:bg-slate-700" : "text-slate-500 hover:bg-slate-100"} ${className}`}
      title={dark ? "Light mode" : "Dark mode"}
    >
      {dark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
